export default {
  allMsg: 'All messages',
  systemMsg: 'System messages',
  personMsg: 'Manual messages',
  unread: 'Unread',
  seeDetail: 'See Details',
  read: 'Read',
  replyNow: 'reply now',
  message: 'Message',
  operateSuccess: 'Operate successfully',
  holder: {
    searchHolder: 'Package No./Order No./Item No.',
  },
  addAcBuy: 'Join AcBuy Discord & Win ¥2000 CASH!',
  joinNow: 'Join Here',
  flatActivity: 'Acbuy Black Friday Sale',
  joinNow1: 'Join Now',
  tips1: 'Enjoy Up to 70% OFF',
  tips2: 'Enter code to claim ￥110 Shipping Coupon instantly!',
}
